import { render } from "./compass.vue?vue&type=template&id=189a2416&scoped=true"
const script = {}

import "./compass.vue?vue&type=style&index=0&id=189a2416&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189a2416"],['__file',"src/js/components/compass.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "189a2416"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('189a2416', __exports__)) {
    api.reload('189a2416', __exports__)
  }
  
  module.hot.accept("./compass.vue?vue&type=template&id=189a2416&scoped=true", () => {
    api.rerender('189a2416', render)
  })

}


export default __exports__